import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { tokens, useFluentTokens } from '../../../../theme/fluent';

const WelcomeToolsPanelStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: tokens.borderRadiusXXXLarge,
    padding: tokens.spacingVerticalL,
    minHeight: 'auto',
    height: 'auto',
    gap: tokens.spacingVerticalL,
  },
  title: {
    display: 'block',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    flex: '1',
  },
  subtitle: {
    display: 'block',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'auto',
    gap: tokens.spacingVerticalS,
    alignItems: 'start',
  },
});

export const useWelcomeToolsPanelStyles = () => {
  const classes = WelcomeToolsPanelStyle();
  const { modeTokens } = useFluentTokens();

  const rootStyle: React.CSSProperties = {
    backgroundColor: modeTokens.colorNeutralBackground1,
    border: `1px solid ${modeTokens.colorNeutralStroke1}`,
  };

  const textStyle: React.CSSProperties = {
    color: modeTokens.colorNeutralForeground1,
  };

  return {
    classes,
    rootStyle,
    textStyle,
  };
};
